import React from "react";

import { UserInfo } from "../common";

// Global context (equivalent to TsAdminContext in tsf-pittouch).
// Holds the current user info; add more shared state here.
export interface AppContextValue {
  userInfo: UserInfo | null;
  setUserInfo: (user: UserInfo | null) => void;
}

export const AppContext = React.createContext<AppContextValue>(null!);

export function useApp(): AppContextValue {
  return React.useContext(AppContext);
}
